(function () {
  var PL_DAYS_DECLINED = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę',
                          'w czwartek', 'w piątek', 'w sobotę'];

  function skipWeekend(d) {
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d;
  }

  // Whole-day difference between two dates, ignoring time-of-day.
  function dayDiff(a, b) {
    var da = new Date(a.getFullYear(), a.getMonth(), a.getDate());
    var db = new Date(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.round((da - db) / 86400000);
  }

  function calcDelivery(now, cutoff, inventory) {
    var hour = now.getHours();
    var dow  = now.getDay(); // 0=Sun
    var before = hour < cutoff;
    var add;

    if (dow === 0) {
      add = 2;
    } else if (dow >= 1 && dow <= 3) {
      add = before ? 1 : 2;
    } else if (dow === 4) {
      add = before ? 1 : 4;
    } else if (dow === 5) {
      add = before ? 3 : 4;
    } else {
      add = 3;
    }

    var from = new Date(now);
    from.setDate(from.getDate() + add);
    skipWeekend(from);

    if (inventory <= 0) {
      from.setDate(from.getDate() + 5);
      skipWeekend(from);
    }

    return from;
  }

  function calcPickup() {
    return 'pon–pt 11:00–18:00 · sob 11:00–15:00';
  }

  function render(container, inventory) {
    // Tryb urlopowy, faza 'delay': serwer wypuscil ten blok tylko dla produktow
    // na zamowienie, a ich wiersz mowi o czasie skompletowania, nie o dacie
    // wysylki. Nie ruszamy go — kazde przeliczenie tutaj skonczyloby sie
    // obietnica ("Wysylka juz jutro"), ktorej w urlopie nie dotrzymamy.
    // Wiersza odbioru osobistego nie ma w DOM, bo butik jest zamkniety.
    var onDemand = inventory <= 0;

    // Nota urlopowa chodzi w parze z wierszem — dla wariantu na zamowienie jej
    // tresc jest nieprawdziwa. Gdy produkt ma wiersz made-to-order, wlascicielem
    // noty jest made-to-order.js; nie przelaczamy jej z dwoch miejsc naraz.
    if (!document.querySelector('[data-mto-notice]')) {
      var vacationNote = document.querySelector('[data-vacation-pdp]');
      if (vacationNote) vacationNote.style.display = onDemand ? 'none' : '';
    }

    if (container.dataset.vacationDelay === 'true') {
      // Blok wychodzi w urlopie tylko dla produktow na zamowienie. Gdy klient
      // przelaczy sie na wariant dostepny od reki, wiersz znika zamiast
      // pokazywac termin skompletowania, ktory go nie dotyczy.
      var delayRow = container.querySelector('[data-shipping-delivery-row]');
      if (delayRow) delayRow.style.display = onDemand ? '' : 'none';
      return;
    }

    var cutoff  = parseInt(container.dataset.cutoff, 10) || 14;
    var carrier = container.dataset.carrier || 'InPost / kurier';
    var now     = new Date();
    // On Sat/Sun there's no same-day cutoff that means anything (no
    // shipments go out those days), so always show "Wysyłka już ...".
    var before  = now.getHours() < cutoff && now.getDay() !== 0 && now.getDay() !== 6;

    var from = calcDelivery(now, cutoff, inventory);
    var diff = dayDiff(from, now);
    var rangeLabel;
    if (diff === 1) {
      rangeLabel = 'jutro';
    } else if (diff === 2) {
      rangeLabel = 'pojutrze';
    } else {
      rangeLabel = PL_DAYS_DECLINED[from.getDay()];
    }

    var winEl = container.querySelector('[data-shipping-window]');
    if (winEl) winEl.textContent = rangeLabel;

    var preorderLabelEl = container.querySelector('[data-preorder-label]');
    var shippingRangeEl = container.querySelector('[data-shipping-range]');
    if (preorderLabelEl) preorderLabelEl.style.display = inventory <= 0 ? '' : 'none';
    if (shippingRangeEl) shippingRangeEl.style.display = inventory <= 0 ? 'none' : '';

    var cutoffEl = container.querySelector('[data-cutoff-line]');
    if (cutoffEl) {
      if (inventory <= 0) {
        // Pre-order items don't ship today/tomorrow - the "Wysyłka już ..."
        // messaging would be misleading given the delivery date is already
        // 5+ days out.
        cutoffEl.textContent = 'Wysyłka po skompletowaniu';
      } else if (before) {
        cutoffEl.textContent = 'Zamów dziś do ' + cutoff + ':00 · Wysyłka już dziś';
      } else {
        // "Zamów jutro do ..." reads as "don't bother ordering today" -
        // instead, tell the customer when the order ships, since ordering
        // now still gets them that shipment. Shipment day is simply the
        // next day, pushed to Monday if it would land on a weekend.
        var shipment = new Date(now);
        shipment.setDate(shipment.getDate() + 1);
        if (shipment.getDay() === 6) shipment.setDate(shipment.getDate() + 2);
        else if (shipment.getDay() === 0) shipment.setDate(shipment.getDate() + 1);
        var label = dayDiff(shipment, now) === 1 ? 'jutro' : PL_DAYS_DECLINED[shipment.getDay()];
        cutoffEl.textContent = 'Wysyłka już ' + label + ' · ' + carrier;
      }
    }

    var pickupEl = container.querySelector('[data-pickup-window]');
    if (pickupEl) pickupEl.textContent = calcPickup();
  }

  function init() {
    // Celujemy w kontener po data-cutoff, a nie po samej klasie: .pdp-shipping
    // nosza takze pasek z linkiem do poradnika i blok kart podarunkowych,
    // a w trybie urlopowym (faza 'delay') ten wlasciwy w ogole nie wychodzi.
    var container = document.querySelector('.pdp-shipping[data-cutoff]');
    if (!container) return;

    var inventory = parseInt(container.dataset.inventory, 10);
    if (isNaN(inventory)) inventory = 1;
    var preorderEnabled = container.dataset.preorder === 'true';
    var snuzTemplate = container.dataset.snuzTemplate === 'true';

    render(container, preorderEnabled ? inventory : 1);

    // Re-render when variant changes
    var productData = null;
    try {
      var jsonEl = document.querySelector('script.product-json');
      if (jsonEl) productData = JSON.parse(jsonEl.textContent);
    } catch (e) {}

    if (productData) {
      document.addEventListener('change', function (e) {
        if (!e.target.closest('.js-variant-selector, [name="id"]')) return;
        var vidEl = document.querySelector('.formVariantId[name="id"]');
        if (!vidEl) return;
        var vid = parseInt(vidEl.value, 10);
        var variant = productData.variants.find(function (v) { return v.id === vid; });
        if (!variant) return;
        container.style.display = variant.available ? '' : 'none';
        if (variant.available) {
          var variantInventory = variant.inventory_quantity || 0;
          var isPreorder = snuzTemplate && variantInventory <= 0;
          render(container, isPreorder ? variantInventory : 1);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
